import OtpBox from "components/GlobalNav/UserProfile/screens/otpBox";
import React, { useState, useEffect, useRef, useContext } from "react";
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import { HOSTNAME } from 'constants/base'
import { checkForLinkingNudge, getLinkedEmailsList, verifyOtpForSignIn, sendOtpForSignIn } from 'api/flights/results'
import { isEmpty, resolveKeysInObjectsArrays, checkHiFiveFlow } from 'utils/browserHelper'
import { errorConfig } from '../../components/GlobalNav/UserProfile/screens/errorConfig'
import Clevertap from 'analytics'
import { fetchUserProfileData } from 'api/flights/itinerary'
import logError from 'utils/logError'
import { UserProfileContext } from "context/itinerary";
import USER_PROFILE_PAGE_CONTANTS from "components/GlobalNav/UserProfile/UserProfileConstants";
import { ProfileDataContext } from "context/flights/results";
import { Toast } from "@cleartrip/bento";
import { Col, Container, Row } from "@cleartrip/bento/components/Grid";

export const OtpBlock =({
    toggle,
    mobileNumber,
    defaultCountryCode,
    setPageName,
    rememberCheckedStatus,
    email,
    toggleModalAndClosePage,
    setLinkedEmails,
    setUserSignedIn,
    setLoginCase,
    superCoinAddNumber,
    superCoinLogin,
    setApiError,
    itineraryId,
    inlineLogin,
    abLogin ='a',
    abInline ='a',
    startCounter,
    isInline,
    getOtpClicked
}) => {
    const [elementInFocus, setElemntInFocus] = useState(0)
    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
    const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]
    const [otpValidationError, setOtpValidationError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    // const [apiError, setApiError] = useState('')
    const [retriesLeft, setRetriesLeft] = useState(4)
    const [countDown, setCountDown] = useState(0)
    const [loading, setLoading] = useState(false)
    const [userData, setUserData] = useContext(UserProfileContext)
    const [userProfile, setUserProfile] = useContext(ProfileDataContext)

    const [timerId, setTimerId] = useState(null);
    const [paused, setPaused] = useState(false);

    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]

    const otpString = otpDigits.join('')
    const otpLength = email ? 6: 4
    const isHiFiveFlow = checkHiFiveFlow(pathname)
    let resendMsg = inlineLogin ? 'Resend OTP' : 'Resend'
    let resendMsgClasses = inlineLogin ? 'c-grey-70' : 'c-neutral-200'
    let resendMsgParentClass = inlineLogin ? 'fs-2' : 'fs-2 fw-500 ml-1'
   

    useEffect(() => {
        if (otpValidationError) {
            clearOtp()
        }
    },[otpValidationError])

    useEffect(() => {
        if (isInline) {
            setOtpValidationError('')       
        if(getOtpClicked ) {
            clearOtp()
        }
    }
    }, [getOtpClicked])

    useEffect(() => {
        refs[0]?.current?.focus()
        // countDownHandler(inlineLogin ? 20 : 30)
        if (!inlineLogin) {
            ClevertapEvent({
                actionName: 'login_OTP_modal_opened',
                actionType: 'Button',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',

            currentPage: pagePath
        })
        }
    }, [])

    useEffect(() => {
        if (!startCounter) {
          clearTimeout(timerId);
          setTimerId(null);
          setCountDown(0);
        } else {
          if (!paused && !timerId) {
            countDownHandler(inlineLogin? 20 : 30);
          } else {
            setPaused(false);
          }
        }
      }, [startCounter, timerId]);


    const getUserProfileData = async () => {
        try {
            let UserProfileResponse = await fetchUserProfileData(itineraryId)
            setUserData(UserProfileResponse.data)
        } catch (e) {
            logError(e)
            console.log('User Profile api error', e)
        }
    }
    const countDownHandler = (countDown, lastCountdown = false) => {
        if (countDown === 0) {
            setPaused(true);
            clearTimeout(timerId);
            setTimerId(null);
            return;
        } else {
            if (countDown === 1 && lastCountdown) {
                setRetriesLeft(-1);
            }
            const updatedCountDown = countDown - 1;
            setCountDown(updatedCountDown);
            const newTimerId = setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000);
            setTimerId(newTimerId);
        }
    }
    const clearOtp = () => {
        const emptyOtpDigits = ['', '', '', '', '', '']
        setOtpDigits(emptyOtpDigits)
        refs[0]?.current?.focus()
    }
    const resendOtp = async () => {
        ClevertapEvent({
            actionName: 'resend_otp_clicked',
            platform: 'desktop',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',
            is_logged_in: 'no',
            domainName: 'www.cleartrip.com'
        })
        // send otp logic
        //set retries = -1 if limit exceed
        setApiError('')
        if (countDown !== 0 || retriesLeft <= 0) {
            return
        } else {
            try {
                const payload = {
                    type: 'MOBILE',
                    value: mobileNumber,
                    countryCode: defaultCountryCode,
                    action: email ? 'UPDATE_MOBILE' : 'SIGNIN'
                }
                const response = await sendOtpForSignIn(payload)
                const { status, data, error } = response || {}
                if (status === 202) {
                    const { action } = data || {}
                    clearOtp()
                    countDownHandler(inlineLogin? 20 : 30)
                } else {
                   
                    const { response = { data: {} } } = error || {}
                    const { data = {} } = response
                    const { message } = data
                    const err = errorConfig[message] || errorConfig.default
                    if (isEmpty(email)) {
                        ClevertapEvent({
                            actionName: 'Error_Occured_Login_modal',
                            actionType: 'Button',
                            page:
                                pagePath === 'results'
                                    ? 'SRP'
                                    : isEmpty(pagePath) || isHiFiveFlow
                                    ? 'HP'
                                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                    ? 'Itinerary'
                                    : 'Confirmation_Page',

                            currentPage: pagePath,
                            error_type:
                                message === 'OTP_SEND_LIMIT_EXCEEDED' ? 'OTP limit exceeded' : 'OTP generation failed'
                        })
                    }
                    // setApiError(err)
                    
                    if (message === 'OTP_SEND_LIMIT_EXCEEDED') {
                        setRetriesLeft(-1)
                    }
                }
            } catch (e) {
                console.log('Resend api error', e)
            }
        }
    }

    const getOtpValue = () => {
        const otp = otpDigits.join('')
        return otp
    }
    useEffect(() => {
        if (otpString?.length === otpLength) {
            verifyOtp()
        }
    }, [otpString?.length])

    const setElementInFocus = index => {
        setElemntInFocus(index)
        refs[index]?.current?.focus()
    }

    const otpChangeHandler = (event, index) => {
        setApiError('')
        const value = event.nativeEvent.data || event.target.value
        const numberValue = Number(value)
        if (value === ' ') return
        if (value === '') {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = ''
            setOtpDigits(otpFieldValues)
            return
        }
        if (numberValue >= 0 && Number.isInteger(numberValue)) {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = value % 10
            setOtpDigits(otpFieldValues)
            setElementInFocus(index + 1)
            return
        }
    }
    const otpCursorHandler = (event, index) => {
        if (event.keyCode === 37) {
            setElementInFocus(index - 1)
        }
        if (event.keyCode === 39) {
            setElementInFocus(index + 1)
        }
        if (event.keyCode === 8) {
            if (event.target.value === '') {
                const otpFieldValues = [...otpDigits]
                const indexToRemove = index - 1
                if (indexToRemove < 0) {
                    return
                }
                otpFieldValues[indexToRemove] = ''
                setOtpDigits(otpFieldValues)
                setElementInFocus(indexToRemove)
            } else {
                const otpFieldValues = [...otpDigits]
                otpFieldValues[index] = ''
                setOtpDigits(otpFieldValues)
            }
        }
    }

    const verifyOtp = async () => {
        setOtpValidationError('')
        dataLayerGA({ section: 'Login' }, 'login_verify_clicked')
        ClevertapEvent({
            actionName: 'Entered_OTP_on_login_modal',
            actionType: 'Button',
            login_cookie: abInline,
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            currentPage: pagePath
        })
        setIsLoading(true)
        const otp = getOtpValue()
        const payload = {
            type: 'MOBILE',
            value: mobileNumber,
            countryCode: "+91",
            action: email ? 'UPDATE_MOBILE' : 'SIGNIN',
            otp
        }
        let customHeader = {}
        if (isHiFiveFlow) {
            const ref = pathname[2] || ''
            customHeader = {
                ...customHeader,
                'referral-link': `https://${HOSTNAME === 'www.cleartrip.com' ? 'm' : 'qa2m'}.cltp.in/ref/${ref}`
            }
        }
        try {
            const response = await verifyOtpForSignIn(payload, customHeader)
            const { status, data, error } = response || {}

            if (status === 200) {
                const { action } = data || {}
                if (superCoinAddNumber || superCoinLogin) {
                    Clevertap.event('Otp_Verification', {
                        action_name: superCoinAddNumber ? 'phone verification' : 'Login verification',
                        status: 'successful verification',
                        is_logged_in: 'yes'
                    })
                }
                if (action === 'SIGNIN') {
                    let popupLogin = false
                    const obj = JSON.parse(window.sessionStorage.getItem('loginPopup'))
                    localStorage.setItem('LoginToastShown', 'true')
                    if (pagePath === 'itinerary' && obj?.flightIternary) {
                        popupLogin = true
                    } else if (pagePath === undefined && obj?.flightHome) {
                        popupLogin = true
                    }
                    ClevertapEvent({
                        actionName: 'Login_succesful',
                        actionType: 'Button',
                        action:'signin',
                        login_cookie: abInline,
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath,
                        login_type: 'Mobile',
                        first_time_login: 'No',
                        auto_pop: popupLogin,
                        keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
                    })
                    if (pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary') {
                        const resp = await getUserProfileData()
                        setUserSignedIn(true)
                        toggleModalAndClosePage(false)
                    } else {
                        setUserSignedIn(true)
                        if (isHiFiveFlow) {
                            setLoginCase(action)
                            toggleModalAndClosePage(false)
                        } else {
                            toggleModalAndClosePage()
                        }
                    }

                }
                if (action === 'SIGNUP') {
                    let popupLogin = false
                    const obj = JSON.parse(window.sessionStorage.getItem('loginPopup'))
                    localStorage.setItem('SignupToastShown', 'true')
                    if (pagePath === 'itinerary' && obj?.flightIternary) {
                        popupLogin = true
                    } else if (pagePath === undefined && obj?.flightHome) {
                        popupLogin = true
                    }
                    ClevertapEvent({
                        actionName: 'Login_succesful',
                        actionType: 'Button',
                        action:'signup',
                        login_cookie: abInline,
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath,
                        login_type: 'Mobile',
                        first_time_login: 'Yes',
                        auto_pop: popupLogin,
                        keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
                    })
                    setUserSignedIn(true)
                    if (isHiFiveFlow) {
                        Clevertap.event('New_signup', {
                            signup_source: 'Hi5_link'
                        })
                        setLoginCase(action)
                        setPageName(USER_PROFILE_PAGE_CONTANTS.WHATSAPP_AUTHENTICATION)
                        return
                    }
                    if (pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary') {
                        const resp = await getUserProfileData()
                        toggleModalAndClosePage(false)
                    } else {
                        const payload = {
                            mobileNumber,
                            countryCode: defaultCountryCode
                        }
                        const res = await getLinkedEmailsList(payload)
                        const { status, data, error } = res || {}
                        if (status === 200) {
                            ClevertapEvent({
                                action_name: 'existing_email_modal_opened',
                                action: 'signup',
                                page:
                                    pagePath === 'results'
                                        ? 'SRP'
                                        : isEmpty(pagePath) || isHiFiveFlow
                                        ? 'HP'
                                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                        ? 'Itinerary'
                                        : 'Confirmation_Page',
                                is_logged_in: 'yes'
                            })
                            setLinkedEmails(data)
                            setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED)
                       
                        } else {
                            const { response = { data: {} } } = error || {}
                            const { data = {} } = response
                            const { message } = data
                            const err = errorConfig[message] || errorConfig.default
                            // setApiError(err)
                            setPageName(USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS)
                        }
                    }
                }
                if (action === 'UPDATE_MOBILE') {
                    toggle()
                    setUserProfile({
                        ...userProfile,
                        mobile: mobileNumber,
                        countryCode: defaultCountryCode,
                        mobileVerified: true
                    })
                }
            } else {
                const { response = { data: {} } } = error || {}
                const { data = {} } = response
                const { message } = data
                const errRes = errorConfig[message] || errorConfig.default

                if (isEmpty(email)) {
                    ClevertapEvent({
                        actionName: 'Error_Occured_Login_modal',
                        actionType: 'Button',
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath,
                        error_type: 'OTP verification failed'
                    })
                }
                if (message === 'INVALID_OTP') {
                    if (superCoinAddNumber || superCoinLogin) {
                        Clevertap.event('Air_UI_Action', {
                            action_name: superCoinAddNumber ? 'phone verification' : 'Login verification',
                            status: 'incorrect otp',
                            is_logged_in: 'no'
                        })
                    }
                    setOtpValidationError(errRes)
                } else {
                    setApiError(errRes)
                }
            }
        } catch (e) {
            console.log('verify Otp api error', e)
        }
        setIsLoading(false)
    }
    const inputBoxArray = email ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4]
    const otpBlock = inputBoxArray?.map((element, index) => {
        return (
            <OtpBox
                key={index}
                onKeyDown={e => otpCursorHandler(e, index)}
                onChange={e => otpChangeHandler(e, index)}
                onMouseDownCapture={() => {
                    setElementInFocus(index)
                }}
                ref={refs[index]}
                value={otpDigits[index]}
                inlineLogin={inlineLogin}
                style={{
                    margin: `11px ${index === 5 ? '0px' : email ? '7px' : '10px'} 14px 0px`,
                    border: otpValidationError
                        ? ' solid 1px #ff3c2b'
                        : refs[index]?.current === document.activeElement
                        ? 'solid 1px #36c'
                        : 'solid 1px #e6e6e6'
                }}
            />
        )
    })

    return(
        <>
            <div>{otpBlock}</div>
            {otpValidationError && (
                <div className="c-error-500 mb-3" style={{ marginTop: '-8px' }}>
                    {otpValidationError}
                </div>
            )}
            <div style={{ marginBottom: inlineLogin ? '29px' : '8px' }}>
                <span className="fs-2 c-neutral-700">{inlineLogin ? '' : "Haven't received OTP?"}</span>
                <span
                    onClick={resendOtp}
                    className={`${resendMsgParentClass} ${
                        retriesLeft === -1
                            ? `${resendMsgClasses}`
                            : countDown !== 0
                            ? `${resendMsgClasses}`
                            : isLoading
                            ? `${resendMsgClasses}`
                            : 'c-blue c-pointer'
                    }`}
                >
                    {retriesLeft === -1
                        ? `${resendMsg}`
                        : countDown !== 0
                        ? `${resendMsg} (${countDown}s)`
                        : `${resendMsg}`}
                </span>
            </div>

        </>
    )
}